import { useEffect, useState } from 'react'

function getColor(score) {
  if (score >= 75) return 'bg-green-500'
  if (score >= 50) return 'bg-civitas-gold'
  if (score >= 25) return 'bg-orange-400'
  return 'bg-red-400'
}

export default function MatchBar({ score, label, animate = true, height = 'h-3' }) {
  const [width, setWidth] = useState(0)
  // AB#698: null means we have no positions for this candidate, which is a
  // different statement from a low match. Rendering it as a number — or as 0% —
  // tells a voter something the data does not support.
  const unscorable = score === null || score === undefined

  useEffect(() => {
    if (unscorable) { setWidth(0); return }
    if (animate) {
      const t = setTimeout(() => setWidth(score), 100)
      return () => clearTimeout(t)
    } else {
      setWidth(score)
    }
  }, [score, animate, unscorable])

  if (unscorable) {
    return (
      <div className="w-full">
        {label && <div className="text-sm text-gray-600 mb-1">{label}</div>}
        <div className={`w-full ${height} bg-gray-100 rounded-full overflow-hidden`}>
          <div className={`${height} w-full bg-[repeating-linear-gradient(45deg,#e5e7eb,#e5e7eb_6px,#f3f4f6_6px,#f3f4f6_12px)]`} />
        </div>
        <p className="text-xs text-gray-500 mt-1">
          No recorded positions — we can&rsquo;t score this candidate yet.
        </p>
      </div>
    )
  }

  return (
    <div className="w-full">
      {label && (
        <div className="flex justify-between items-center mb-1">
          <span className="text-sm text-gray-600">{label}</span>
          <span className="text-sm font-semibold text-civitas-navy">{score}%</span>
        </div>
      )}
      <div className={`w-full ${height} bg-gray-100 rounded-full overflow-hidden`}>
        <div
          className={`${height} ${getColor(score)} rounded-full transition-all duration-700 ease-out`}
          style={{ width: `${width}%` }}
        />
      </div>
    </div>
  )
}
